module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_8.482b385a.png";